import {Injectable} from "@angular/core";
import {ActivatedRouteSnapshot, Resolve} from "@angular/router";
import {Observable} from "rxjs";
import {AppStateService} from "../providers/app-state.service";
import {tap} from "rxjs/operators";
import {environment} from "../../environments/environment";
import {MonthlyReportForClientDgSearchResults} from "../models/datagrid-search-results/monthly-report-for-client.dg-search-results.model";
import {MonthlyReportForClientService} from "../providers/monthly-report-for-client.service";

@Injectable()
export class MonthlyReportsForClientResolve implements Resolve<MonthlyReportForClientDgSearchResults> {
  constructor(private monthlyReportForClientService: MonthlyReportForClientService, private appStateService: AppStateService) {
  }

  resolve(route: ActivatedRouteSnapshot): Observable<MonthlyReportForClientDgSearchResults> {
    this.appStateService.updateIsBusySubject(true);
    return this.monthlyReportForClientService.getResults(environment.DEFAULT_RESULTS_LIMIT, 0, 'DESC', 'created').pipe(tap(res => {
      this.appStateService.updateIsBusySubject(false);
    }));
  }
}
